module.exports = __webpack_public_path__ + "static/img/bg-tit2.6759ec61.png";